import { FC, useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";
import WSMPDialog from "components/summary/index/WSMPDialog";
import { classHOC } from "components/app/ClassWrapper";

const JiraStatusRenderer: FC<ICellRendererParams> = ({ data, node }) => {
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => {
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
  };
  if (node.rowPinned) {
    return <></>;
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: data?.ccseJira?.percentDesc !== "N/A" ? "pointer" : "default",
        }}
        onClick={data?.ccseJira?.percentDesc !== "N/A" ? handleDialogOpen : undefined}
      >
        <span>{data?.ccseJira?.percentDesc ?? "N/A"}</span>
        {data?.ccseJira?.percentDesc !== "N/A" && (
          <KeyboardArrowDown style={{ fontSize: "1rem" }} />
        )}
      </div>
      {open && (
        <WSMPDialog
          open={open}
          onClose={handleDialogClose}
          data={data?.ccseJira?.WSMPdata ?? []}
        />
      )}
    </>
  );
};

export default classHOC(JiraStatusRenderer);
